var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Copright    2021miniJD任务数据优化平台    版权所有")])}
var staticRenderFns = []

export { render, staticRenderFns }